<template>
  <div class="sidebar-wrapper d-flex justify-content-between flex-column flex-grow-1">
    <div class="p-2">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        aria-controls="sidebar-add-new-event"
        :aria-expanded="String(isEventHandlerSidebarActive)"
        variant="primary"
        block
        @click="$emit('update:isEventHandlerSidebarActive', true);"
      >
      Add Booking
      </b-button>
      <div class="mt-3">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">Room</span>
        </h5>
        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedCalendars"
            name="event-filter"
            stacked
          >
            <b-form-checkbox
              @change="emit_now"
              v-for="item in calendarOptions"
              :key="item.label"
              name="event-filter"
              :value="item.id"
              class="mb-1"
              :class="`custom-control-${item.color}`"
            >
              {{ item.label }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

      </div>
    </div>
    <b-img :src="require('@/assets/images/pages/calendar-illustration.png')" />
  </div>
</template>

<script>
import {
  BButton, BFormGroup, BFormCheckboxGroup, BFormCheckbox, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import useCalendarSidebar from './useCalendarSidebar'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BImg,
    BFormCheckbox,
    BFormGroup,
    BFormCheckboxGroup,
  },
  props: {
    isEventHandlerSidebarActive: {
      type: Boolean,
      require: true,
    },
  },
  created() {
  //  console.clear()
    this.get_room()
  },
  methods: {
    emit_now() {
      console.log("emit")
      this.$emit('fetch',this.selectedCalendars)
    },
    get_room() {
      this.$http.get(`https://valleyfitstudio.gfs.hk/api/v1/pro/rooms/?enabled=y&center_id=`+ this.$store.getters['center/currentCenterId'])
        .then(res => {
          this.calendarOptions = res.data.rooms
        })
    },
  },
  data() {
    return {
      calendarOptions:[],
      selectedCalendars:[],
    }
  },
}
</script>

<style>

</style>
